import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StudentSelector from './StudentSelector';
import SsoAuthenticationLink from '../SsoRedirect';

const ApplyNow = ({ customerId }) => {
  const [selectedStudents, setSelectedStudents] = useState([]);
  return (
    <StudentSelector
      selectedStudents={selectedStudents}
      setSelectedStudents={setSelectedStudents}
      description="Select a student from below to pre-load application form with the saved student's information."
      buttons={[
        (
          <SsoAuthenticationLink buttonText='Confirm Application' className='btn btn-primary' disabled={selectedStudents.length === 0} schoolId={customerId} studentId={selectedStudents[0]} />
        )
      ]}
      title='Apply Now'
    />
  );
};
ApplyNow.propTypes = {
  customerId: PropTypes.string.isRequired
};

export default ApplyNow;
